import React, { useState, useEffect } from "react";

const Reviews = () => {
  const [userRating, setUserRating] = useState(0);
  const [userReview, setUserReview] = useState("");
  const [reviews, setReviews] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const s = localStorage.getItem("reviews");
    if (s) setReviews(JSON.parse(s));
  }, []);

  const avg = reviews.length ? reviews.reduce((a, r) => a + r.rating, 0) / reviews.length : 0;

  const submit = () => {
    if (!userRating) return;
    const next = [...reviews, { userId: "me", username: "You", rating: userRating, review: userReview }];
    setReviews(next);
    localStorage.setItem("reviews", JSON.stringify(next));
    setUserRating(0); setUserReview(""); setOpen(false);
  };

  return (
    <div className="oot-reviews">
      <div className="oot-reviews-head">
        <h3>Reviews ({reviews.length})</h3>
        <button className="oot-btn oot-btn-ghost" onClick={() => setOpen(true)}>Write a review</button>
      </div>
      <p className="oot-rev-avg">★ {avg.toFixed(1)} / 5 average rating</p>

      {reviews.length === 0 ? (
        <p className="oot-rev-avg">No reviews yet — be the first to review this product.</p>
      ) : (
        reviews.slice(0, 8).map((r, i) => (
          <div className="oot-rev-item" key={i}>
            <div className="oot-rev-stars">{"★".repeat(r.rating)}{"☆".repeat(5 - r.rating)}</div>
            <div className="who">{r.username}</div>
            <div>{r.review}</div>
          </div>
        ))
      )}

      {open && (
        <div className="oot-modal-ov" onClick={() => setOpen(false)}>
          <div className="oot-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Write a review</h3>
            <div className="oot-stars-pick">
              {[1, 2, 3, 4, 5].map((n) => (
                <span key={n} className={n <= userRating ? "on" : ""} onClick={() => setUserRating(n)}>★</span>
              ))}
            </div>
            <textarea className="oot-input" style={{ height: 120, marginTop: 14 }}
              placeholder="Share your thoughts…" value={userReview} onChange={(e) => setUserReview(e.target.value)} />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 14 }}>
              <button className="oot-btn oot-btn-ghost" onClick={() => setOpen(false)}>Cancel</button>
              <button className="oot-btn oot-btn-primary" onClick={submit} disabled={!userRating}>Submit</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reviews;
